import lodash from "lodash";
import store from '../store';
import axios from "axios";
import moment from 'moment';

const helpFunctions = {
    modal_functions: {
        openModal(ref) {
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
    },
    reg_exp: "",
    found_models: [],
    found_model_ids: [],
    model_ids_for_search: [],
    headers: {
        job_queue: ["id", "name", "date"],
        introductions: ["Draggable", "sort_order", "page", "title", "placement", "introduction_action", "introduction_active", "actions"],
    },
    footer_props: {
        itemsPerPageOptions: [
            {value:15, title:'15'},
            {value:25, title:'25'},
            {value:50, title:'50'},
            {value:75, title:'75'},
            {value:100, title:'100'},
            {value:125, title:'125'},
            {value:150, title:'150'},
            {value:175, title:'175'},
            {value:200, title:'200'},
            {value:250, title:'250'},
            {value:300, title:'300'}
        ],
        itemsPerPageText: "Rows per page:",
    },
    table_options: {
        itemsPerPage: 15,
        page: 1,
        sortBy: [{"key": "id", "order": "asc"}],
    },
    margins: {
        margin_top: 10,
        margin_bottom: 10,
        margin_left: 10,
        margin_right: 10,
    },
    field_types: [
        { value: "text_field", text: store.getters.translate("text_field") },
        { value: "text_area", text: store.getters.translate("text_area") },
        { value: "boolean", text: store.getters.translate("boolean") },
        { value: "select_single", text: store.getters.translate("select_single") },
        { value: "select_multiple", text: store.getters.translate("select_multiple") },
        { value: "date", text: store.getters.translate("date") },
        { value: "read_only", text: store.getters.translate("read_only") },
        { value: "link", text: store.getters.translate("link") },
    ],
    question_types: [
        { value: "text_field", text: store.getters.translate("text_field") },
        { value: "text_area", text: store.getters.translate("text_area") },
        { value: "boolean", text: store.getters.translate("boolean") },
        { value: "select_single", text: store.getters.translate("select_single") },
        { value: "select_multiple", text: store.getters.translate("select_multiple") },
        { value: "date", text: store.getters.translate("date") },
        { value: "numeric_range", text: store.getters.translate("numeric_range") },
        { value: "numeric_with_units", text: store.getters.translate("numeric_with_units") },
        { value: "rating_scale", text: store.getters.translate("rating_scale") },
        { value: "stopwatch", text: store.getters.translate("stopwatch") },
        { value: "signature", text: store.getters.translate("signature") },
    ],
    plan_work_types: {
        level_0: ["define_owners_project_requirements", "establish_commissioning_strategy", "write_initial_project_plan"],
        level_1: ["test_equipment_at_factory", "verify_components_match_specifications"],
        level_2: ["inspect_equipment_on_delivery", "check_for_transport_damage", "verify_installation_matches_design_drawings"],
        level_3: ["mechanical_electrical_completion_checklist", "flush_pipes", "cold_loop_checks", "energize_standalone_equipment"],
        level_4: ["test_automated_controls", "test_sequences_of_operation", "test_subsystems_together"],
        level_5: ["integrated_systems_test", "life_safety_hvac_power_integration"],
        level_6: ["operator_training", "finalize_documentation", "clear_punch_lists", "transition_to_owner"],
    },
    pages: {
        actions: { name: "actions", model: "action" },
        assets: { name: "assets", model: "asset" },
        companies: { name: "companies", model: "company" },
        contacts: { name: "contacts", model: "contact" },
        custompermissions: { name: "custompermissions", model: "custompermission" },
        dashboard: { name: "dashboard", model: "dashboard" },
        documents: { name: "documents", model: "document" },
        employees: { name: "employees", model: "employee" },
        fields: { name: "fields", model: "field" },
        floors: { name: "floors", model: "floor" },
        home: { name: "home", model: "home" },
        introductions: { name: "introductions", model: "introduction" },
        locations: { name: "locations", model: "location" },
        modellogs: { name: "modellogs", model: "modellog" },
        notes: { name: "notes", model: "note" },
        notifications: { name: "notifications", model: "notification" },
        people: { name: "people", model: "people" },
        plans: { name: "plans", model: "plan" },
        projects: { name: "projects", model: "project" },
        portal: { name: "portal", model:"portal" },
        profile: { name: "profile", model: "employee" },
        roles: { name: "roles", model:"role" },
        settings: { name: "settings", model: "setting" },
        scripts: { name: "scripts", model: "script" },
        reports: { name: "reports", model: "report" },
        scripttemplates: { name: "scripttemplates", model: "scripttemplate" },
        //NO STABU FOR INBEDRIJFSTELLERS
        // stabu: { name: "stabu", model: "stabu" },
        tags: { name: "tags", model: "tag" },
        tickets: { name: "tickets", model: "ticket" },
        tokens: { name: "tokens", model: "token" },
        translations: { name: "translations", model: "translation" },
        triggers: { name: "triggers", model: "trigger" },
        workflows: { name: "workflows", model: "workflow" },
        users: { name: "users", model: "user" },
    },
    base_table_includable_options: {
        companies: {
            locations: {
                create: true,
                link: true,
                detachable: true,
            },
            projects: {
                create: true,
            },
            contacts: {
                create: true,
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
            }
        },
        contacts: {
            companies: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
            }
        },
        employees: {
            roles: {
                link: true,
                detachable: true,
            },
            tokens: {
                create: true,
            },
            companies: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
            }
        },
        locations: {
            floors: {
                create: true,
            },
            scripts: {
                create: true,
            },
            projects: {
                create: true,
            },
            companies: {
                link: true,
                detachable: true,
            },
        },
        plans: {
            reports: {}
        },
        projects: {
            plans: {
                create: true,
            },
            tickets: {
                create: true,
            },
            reports: {},
            //NO STABU FOR INBEDRIJFSTELLERS
            // stabu: {
            //     link: true,
            //     detachable: true,
            // },
            companies: {
                link: true,
                detachable: true,
            },
        },
        roles: {
            users: {
                link: true,
                detachable: true,
            },
        },
    },
    //TABLES FUNCTIONS
    showRecords(all_records, response_fields, advanced_search, page_name) {
        let sorted_array = all_records;
        let field_names = Object.keys(response_fields);
        for (let i = 0; i < field_names.length; i++) {
            if(field_names[i] === 'tags') {
                sorted_array = advanced_search['tags'].length > 0 ? this.sortByTagsBase(sorted_array, advanced_search['tags']) : sorted_array;
            }
            else if (advanced_search[field_names[i]] !== undefined && advanced_search[field_names[i]] !== null && advanced_search[field_names[i]] !== "") {
                if(response_fields[field_names[i]] === 'boolean') {
                    sorted_array = sorted_array.filter(item => (item[field_names[i]] && advanced_search[field_names[i]]) || (!item[field_names[i]] && !advanced_search[field_names[i]]));
                }
                else {
                    sorted_array = sorted_array.filter(item => item[field_names[i]] && item[field_names[i]] !== "" && item[field_names[i]].toLowerCase().includes(advanced_search[field_names[i]].toLowerCase()));
                }
            }
            if(sorted_array.length === 0) {
                break;
            }
        }
        return sorted_array;
    },
    sortByTagsBase(sorted_array, tags) {
        let response = [];
        for (let i = 0; i < sorted_array.length; i++) {
            if (sorted_array[i].tags.length > 0) {
                let found = false;
                for (let x = 0; x < sorted_array[i].tags.length; x++) {
                    for (let y = 0; y < tags.length; y++) {
                        if (sorted_array[i].tags[x] == tags[y]) {
                            response.push(sorted_array[i]);
                            found = true;
                            break;
                        }
                    }
                    if (found) {
                        break;
                    }
                }
            }
        }
        return response;
    },
    //ASSETS FUNCTIONS
    searchAssetByID(assets, asset_ids) {
        let found_assets = [];
        asset_ids.forEach((asset_id) => {
            let found_asset = this.loopAssetsTree(assets, asset_id);
            if (found_asset) {
                found_assets.push(found_asset);
            }
        });
        return found_assets;
    },
    loopAssetsTree(assets, asset_id) {
        for (let i = 0; i < assets.length; i++) {
            if (assets[i] && assets[i].id === asset_id) {
                return assets[i];
            }
            else if (assets[i] && assets[i].children) {
                let found_asset = this.loopAssetsTree(assets[i].children, asset_id);
                if (found_asset) {
                    return found_asset;
                }
            }
        }
    },
    searchInModelsByID(items) {
        let found = false;
        if (items) {
            items.forEach((item, key) => {
                if (item) {
                    if (item.children) {
                        if (this.searchInModelsByID(item.children)) {
                            found = true;
                        }
                        else if (this.model_ids_for_search.includes(item.id)) {
                            found = true;
                        }
                        else {
                            delete items[key];
                        }
                    }
                    else if (this.model_ids_for_search.includes(item.id)) {
                        found = true;
                    }
                    else {
                        delete items[key];
                    }
                }
            });
        }
        return found;
    },
    customSearch(items, search) {
        this.reg_exp = new RegExp(search, "i");
        this.searchInTree(items);
        let filtered_items = items.filter(function (el) {
            return el != null;
        });
        this.found_models = [];
        this.found_model_ids = [];
        this.getModelsAndIDs(filtered_items);
        return [filtered_items, this.found_model_ids, this.found_models];
    },
    searchInTree(items) {
        let found = false;
        if (items) {
            items.forEach((item, key) => {
                if (item) {
                    if (item.children) {
                        if (this.searchInTree(item.children)) {
                            found = true;
                        } else if (item.name && item.name.match(this.reg_exp)) {
                            found = true;
                        } else {
                            delete items[key];
                        }
                    } else if (item.name && item.name.match(this.reg_exp)) {
                        found = true;
                    } else {
                        delete items[key];
                    }
                }
            });
        }
        return found;
    },
    getModelsAndIDs(items) {
        if (items) {
            items.forEach((item) => {
                if (item) {
                    if (item.children) {
                        this.getModelsAndIDs(item.children);
                    }
                    this.found_models.push(item);
                    this.found_model_ids.push(item.id);
                }
            });
        }
    },
    customSortingAndFiltering(items) {
        this.sortAndFilterModels(items);
        return items;
    },
    sortAndFilterModels(items) {
        items = items.filter(function (el) {
            return el != null;
        });
        if(items.length === 0) {
            return null;
        }
        else {
            items.forEach((item) => {
                items = lodash.sortBy(items, "name");
                if (item.children && Array.isArray(item.children)) {
                    item.children = this.sortAndFilterModels(item.children);
                }
            });
            return items;
        }
    },
    //UNIVERSAL FUNCTIONS
    async getFields(model, action, disabled = false, without_auth = false) {
        await store.dispatch('setLoader', true);
        let additionalModels = {};
        let response;
        if(without_auth) {
            response = await axios.get(store.getters.appUrl + "v2/portal/fields?" + action + "=true&model_type=" + model);
        }
        else {
            response = await axios.get(store.getters.appUrl + "v2/fields?" + action + "=true&model_type=" + model);
        }
        let data = response.data;
        let tags_required = false;
        let usual_fields = [];
        let custom_fields = [];
        let promises = [];
        for (let x = 0; x < data.length; x++) {
            if (data[x].custom_field == 1) {
                if(data[x].field_type === 'select_single' || data[x].field_type === 'select_multiple') {
                    for (let i = 0; i < data[x].available_options.length; i++) {
                        data[x].available_options[i] = {
                            text: store.getters.translate(data[x].available_options[i]),
                            value: data[x].available_options[i],
                        };
                    }
                    data[x].available_options = lodash.sortBy(data[x].available_options, 'text');
                }
                custom_fields.push(data[x]);
            }
            else if(data[x].name === 'tags') {
                tags_required = true;
            }
            else if(disabled) {
                data[x].name = data[x].name.replace('_id', '_name');
                if(data[x].field_type === 'select_single') {
                    data[x].field_type = 'text_field';
                }
                usual_fields.push(data[x]);
            }
            else {
                if(data[x].name === 'project_id') {
                    if(!additionalModels.projects) {
                        additionalModels.projects = this.getAdditionalModelsForDropdowns("project", "id", ["name"], " | ", "closed");
                        promises.push(additionalModels.projects);
                    }
                    data[x].available_options = additionalModels.projects;
                }
                else if(data[x].name === 'location_id') {
                    if(!additionalModels.locations) {
                        additionalModels.locations = this.getAdditionalModelsForDropdowns("location", "id", ["name"]);
                        promises.push(additionalModels.locations);
                    }
                    data[x].available_options = additionalModels.locations;
                }
                else if(data[x].name === 'plan_id') {
                    if(!additionalModels.plans) {
                        additionalModels.plans = this.getAdditionalModelsForDropdowns("plan", "id", ["name"]);
                        promises.push(additionalModels.plans);
                    }
                    data[x].available_options = additionalModels.plans;
                }
                else if(data[x].name === 'script_id') {
                    if(!additionalModels.scripts) {
                        additionalModels.scripts = this.getAdditionalModelsForDropdowns("script", "id", ["name"]);
                        promises.push(additionalModels.scripts);
                    }
                    data[x].available_options = additionalModels.scripts;
                }
                else if(data[x].name === 'user_id') {
                    if(!additionalModels.users) {
                        additionalModels.users = this.getAdditionalModelsForDropdowns("user", "id", ["name"]);
                        promises.push(additionalModels.users);
                    }
                    data[x].available_options = additionalModels.users;
                }
                else if(data[x].name === 'responsible_id' || data[x].name === 'consultant_id' || data[x].name === 'informed_id') {
                    if(!additionalModels.employees) {
                        additionalModels.employees = this.getAdditionalModelsForDropdowns("employee", "id", ["name"]);
                        promises.push(additionalModels.employees);
                    }
                    data[x].available_options = additionalModels.employees;
                }
                else if(data[x].name === 'type_of_work') {
                    for (let i = 0; i < data[x].available_options.length; i++) {
                        let option = data[x].available_options[i];
                        data[x].available_options[i] = {
                            value: option,
                            text: store.getters.translate(option),
                            filter: Object.keys(this.plan_work_types).find(level => this.plan_work_types[level].includes(option)),
                        };
                    }
                }
                else if(data[x].field_type === 'select_single' || data[x].field_type === 'select_multiple') {
                    for (let i = 0; i < data[x].available_options.length; i++) {
                        data[x].available_options[i] = {
                            value: data[x].available_options[i],
                            text: store.getters.translate(data[x].available_options[i]),
                        };
                    }
                    data[x].available_options = lodash.sortBy(data[x].available_options, 'text');
                }
                usual_fields.push(data[x]);
            }
        }
        await Promise.all(promises);
        for (let x = 0; x < data.length; x++) {
            if (data[x].available_options && typeof data[x].available_options.then === 'function') {
                data[x].available_options = await data[x].available_options;
            }
        }
        await store.dispatch('setLoader', false);
        return { tags_required: tags_required, usual_fields: usual_fields, custom_fields: custom_fields };
    },
    composeTableHeaders(headers) {
        let new_headers = [];
        headers.forEach((header) => {
            let new_header = { key: header, value: header };
            if(new_header.value === 'Draggable') {
                new_header.title = '';
                new_header.align = "center";
                new_header.width = "60px";
                new_header.sortable = false;
            }
            else if(new_header.value === 'sort_order') {
                new_header.title = store.getters.translate(header);
                new_header.align = "start";
                new_header.width = "100px";
                new_header.sortable = false;
            }
            else if(new_header.value === 'actions') {
                new_header.title = '';
                new_header.align = "center";
                new_header.width = "80px";
                new_header.fixed = true;
                new_header.sortable = false;
            }
            else {
                new_header.title = store.getters.translate(header);
                new_header.align = "start";
                new_header.sortable = true;
            }
            new_headers.push(new_header);
        });
        return new_headers;
    },
    composeFields(fields, add_actions_column) {
        let response = [];
        let field_names = Object.keys(fields);
        for (let i = 0; i < field_names.length; i++) {
            if(store.getters.getUser.superuser || (field_names[i] !== 'mandatory' && field_names[i] !== 'show_on_creation' && field_names[i] !== 'show_on_update')) {
                const field = {
                    title: store.getters.translate(field_names[i]),
                    key: field_names[i],
                    align: "start",
                    fixed: true,
                    sortable: true,
                    value: field_names[i],
                };
                if (fields[field_names[i]] === 'date') {
                    field.sort = (a, b) => {
                        let dateA;
                        let dateB;
                        if(field_names[i] === 'created_at' || field_names[i] === 'updated_at' || field_names[i] === 'last_used_at') {
                            dateA = a ? moment(a).toDate() : null;
                            dateB = b ? moment(b).toDate() : null;
                        }
                        else {
                            dateA = a ? moment(a, 'DD-MM-YYYY', true).toDate() : null;
                            dateB = b ? moment(b, 'DD-MM-YYYY', true).toDate() : null;
                        }

                        // Fall back to new Date if Moment parsing fails
                        // No need to do it because we have only 2 cases:
                        // timestamp for created_at/updated_at and DD-MM-YYYY for everything else
                        /*if (dateA && isNaN(dateA.getTime())) {
                            dateA = a ? new Date(a) : null;
                        }
                        if (dateB && isNaN(dateB.getTime())) {
                            dateB = b ? new Date(b) : null;
                        }*/

                        if (!dateA || isNaN(dateA.getTime())) {
                            if (!dateB || isNaN(dateB.getTime())) {
                                return 0;
                            } else {
                                return -1;
                            }
                        } else if (!dateB || isNaN(dateB.getTime())) {
                            return 1;
                        } else {
                            return dateA.getTime() - dateB.getTime();
                        }
                    }
                }

                response.push(field);
            }
        }
        if (add_actions_column) {
            response.push({
                title: '',
                align: 'center',
                fixed: true,
                sortable: false,
                value: 'actions',
                width: '80px',
            });
        }
        return response;
    },
    async getAdditionalModelsForDropdowns(model, option_id, option_name, separator = " | ", filter) {
        let models = [];
        const response = await axios.post(store.getters.appUrl + "v2/additional-models-for-dropdowns", { model: model, fields: option_name.join(), filter: filter });
        let data = response.data.data ? response.data.data : response.data;
        data.forEach((option) => {
            let text = [];
            for (let i = 0; i < option_name.length; i++) {
                if(option[option_name[i]]) {
                    text.push(store.getters.translate(option[option_name[i]]));
                }
            }
            let record = { value: option[option_id], text: text.join(separator) };
            if(filter) {
                record.filter = option[filter];
            }
            models.push(record);
        });
        return lodash.sortBy(models, "text");
    },
    async getOneFullAdditionalModel(toasted, model, id, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/get-one-additional-model", { model: model, id: id })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return {};
        }
    },
    async getFullAdditionalModels(toasted, model, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/additional-models-full", { model: model })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    },
    async getModelsForTables(toasted, model) {
        await store.dispatch('setLoader', true);
        const response = await axios.get(store.getters.appUrl + "v2/" + model + "?source=site")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    },
    async loadModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.get(store.getters.appUrl + "v2/" + model + "/" + model_id)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            let result = response.data;
            let modelsWithCustomFields = ["companies", "contacts", "employees"];

            if (modelsWithCustomFields.includes(model)) {
                if (result.custom_fields == null || Array.isArray(result.custom_fields) || typeof result.custom_fields !== "object") {
                    result.custom_fields = {};
                }
            }
            return result;
        }
        return false;
    },
    async createModel(toasted, model, record) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model, record)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return response.data;
        }

        return false;
    },
    async createModelSilently(model, record) {
        const response = await axios.post(store.getters.appUrl + "v2/" + model, record);
        return response && response.status === 200;
    },
    async saveModel(toasted, model, record) {
        await store.dispatch('setLoader', true);
        const response = await axios.patch(store.getters.appUrl + "v2/" + model + "/" + record.id, record)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }

        return false;
    },
    async saveModelSilently(model, record) {
        const response = await axios.patch(store.getters.appUrl + "v2/" + model + "/" + record.id, record);
        return response && response.status === 200;
    },
    async deleteModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.delete(store.getters.appUrl + "v2/" + model + "/" + model_id)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_deleted"));
            return true;
        }

        return false;
    },
    async restoreModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/" + model_id + "/restore")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_restored"));
            return true;
        }

        return false;
    },
    async forceDeleteModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.delete(store.getters.appUrl + "v2/" + model + "/" + model_id + "/delete")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_deleted"));
            return true;
        }

        return false;
    },
    async getPDFFile(toasted, url, params) {
        await store.dispatch('setLoader', true);

        const response = await axios.post(store.getters.appUrl + "v2/" + url, params, { responseType: "blob" })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
    },
    async getFile(toasted, id) {
        await store.dispatch('setLoader', true);

        const response = await axios.get(store.getters.appUrl + "v2/files/" + id, { responseType: "blob" })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
    },
    //USED IN QUESTIONS ONLY FOR SAVING FILE VIA DEFAULT FILE CONTROLLER BECAUSE WE DO NOT HAVE THE QUESTION MODEL
    async createFile(toasted, formData) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/files", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return response.data;
        }

        return false;
    },
    //USED IN ALL OTHER CASES FOR SAVING FILES
    async saveFile(toasted, model, formData) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/uploadfiles", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return response.data;
        }
    },
    async deleteFile(toasted, model, params) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/deletefiles", params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            })

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }
    },
    async getCustomRoute(toasted, url, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.get(store.getters.appUrl + "v2/" + url)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }

        return false;
    },
    async postCustomRoute(toasted, url, params, show_success = false, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/" + url, params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            if(show_success) {
                toasted.success(store.getters.translate("success"));
            }
            return response.data;
        }

        return false;
    },
    async patchCustomRoute(toasted, url, params, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.patch(store.getters.appUrl + "v2/" + url, params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }

        return false;
    },
    modelFieldsFilled(toasted, record, fields, ignore_fields = []) {
        let status = true;
        for (let i = 0; i < fields.length; i++) {
            if ((fields[i].name === 'first_name' || fields[i].name === 'last_name') && (!record[fields[i].name] || record[fields[i].name] === '')) {
                toasted.error(store.getters.translate("required_field") + ": " + store.getters.translate('name'));
                status = false;
            }
            else if (fields[i].mandatory && !ignore_fields.includes(fields[i].name) && fields[i].field_type !== 'boolean' && (!record[fields[i].name] || record[fields[i].name] === '')) {
                toasted.error(store.getters.translate("required_field") + ": " + store.getters.translate(fields[i].name));
                status = false;
            }
        }
        return status;
    },
    replaceIDwithNameBaseTable(fields) {
        let new_fields = {};
        for (const key of Object.keys(fields)) {
            if(key !== 'auditable_id' && key !== 'country_of_birth_id' && key !== 'nationality_id') {
                new_fields[key.replace('_id', '_name').replace('_by', '_by_name')] = fields[key];
            }
            else {
                new_fields[key] = fields[key];
            }
        }
        return new_fields;
    },
    replaceIDwithNameBaseTableInc(name) {
        if(name !== 'auditable_id' && name !== 'country_of_birth_id' && name !== 'nationality_id') {
            name = name.replace('_ids', '_names').replace('_id', '_name').replace('_by', '_by_name');
        }
        return name;
    },
    replaceLastChar(model) {
        if(model === 'company') {
            return 'companies';
        }
        else {
            return model + "s";
        }
    },
    getLocalStorageValue(value_name) {
        if (localStorage.getItem(value_name)) {
            return JSON.parse(localStorage.getItem(value_name));
        }
        return null;
    },
    setLocalStorageValue(value_name, value) {
        localStorage.setItem(value_name, JSON.stringify(value));
    },
    getBreadcrumbs(module_name, current = null) {
        let response = [{
            title: "Home",
            disabled: false
        }];
        if(module_name !== "dashboard") {
            response[0].to = "/";
            response[1] = {
                title: store.getters.translate(module_name)
            }
            if(current == null) {
                response[1].disabled = true;
            }
            else {
                response[1].disabled = false;
                response[1].href = "/" + module_name;
                response[2] = {
                    title: current,
                    disabled: true
                }
            }
        }
        return response;
    },
    uid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
    //PORTAL
    status_colors: {
        created: "neutral-700",
        upcoming: "warning",
        in_progress: "primary",
        completed: "success",
        late: "error",
        no_plans: "neutral-700"
    },
    /*
    * STATUS PRIORITIES:
    * COMPLETED
    * LATE
    * IN PROGRESS
    * UPCOMING
    * CREATED
    * */
    projectStatus(project) {
        if(project.plans.length > 0) {
            //ALL PLANS HAS STATUS COMPLETED
            if (!project.plans.find((plan) => plan.status !== "completed")) {
                return "completed";
            }
            //THE PROJECT HAS AT LEAST 1 PLAN WITH OLD COMPLETE DATE
            else if (project.plans.find((plan) => this.planStatus(plan) === "late")) {
                return "late";
            }
            //THE PROJECT HAS AT LEAST 1 PLAN WITH "IN PROGRESS" STATUS
            else if (project.plans.find((plan) => plan.status === "in_progress")) {
                return "in_progress";
            }
            //THE PROJECT HAS AT LEAST 1 PLAN WITH FUTURE START DATE
            else if (project.plans.find((plan) => this.planStatus(plan) === "upcoming")) {
                return "upcoming";
            }
            else {
                return "created";
            }
        }
        return "no_plans";
    },
    planStatus(plan) {
        if (plan.status === "completed") {
            return "completed";
        }
        else if (plan.complete_date && moment(plan.complete_date, "DD-MM-YYYY").isBefore(moment(), "day")) {
            return "late";
        }
        else if (plan.status === "in_progress") {
            return "in_progress";
        }
        else if (plan.start_date && moment(plan.start_date, "DD-MM-YYYY").isAfter(moment(), "day")) {
            return "upcoming";
        }
        else {
            return "created";
        }
    },
    ticketStatus(ticket) {
        if (ticket.status === "completed") {
            return "completed";
        }
        else if (ticket.due_date && moment(ticket.due_date, "DD-MM-YYYY").isBefore(moment(), "day")) {
            return "late";
        }
        else if (ticket.status === "in_progress") {
            return "in_progress";
        }
        else {
            return "created";
        }
    },
    answer_separators: {
        numeric_range: " - ",
        numeric_with_units: " ",
    },
    //A NUMERIC RANGE OR A NUMBER WITH UNITS IS ONLY ANSWERED WHEN ALL ITS PARTS ARE FILLED
    questionAnswered(question, answer) {
        if (!answer.answer) {
            return false;
        }
        if (question.type === 'numeric_range' || question.type === 'numeric_with_units') {
            return String(answer.answer).split(this.answer_separators[question.type]).every(part => part);
        }
        return true;
    },
    //A STOPWATCH ANSWER IS STORED IN SECONDS, THE STOPWATCH AND THE REPORT SHOW IT AS HH:MM:SS, THE SAME AS THE DURATION OF A REPORT
    getDuration(seconds) {
        let duration = moment.duration(seconds, "seconds");
        return Math.floor(duration.asHours()).toString().padStart(2, "0") + ":" + duration.minutes().toString().padStart(2, "0") + ":" + duration.seconds().toString().padStart(2, "0");
    },
}

export default helpFunctions